export default {
  granularity: 'Granularidade',
  monthly: 'Mensal',
  quarterly: 'Trimestral',
  weekly: 'Semanal',
  week: 'Semana',
  missingTitle: 'Título ausente',
  jan: 'Jan',
  feb: 'Fev',
  mar: 'Mar',
  apr: 'Abr',
  may: 'Mai',
  jun: 'Jun',
  jul: 'Jul',
  aug: 'Ago',
  sep: 'Set',
  oct: 'Out',
  nov: 'Nov',
  dec: 'Dez',
  q1: 'T1',
  q2: 'T2',
  q3: 'T3',
  q4: 'T4'
}
